"use client";
import {
  usePopoverStoreProps
} from "./RUY5BUJG.js";
import {
  useStore,
  useStoreProps
} from "./RTNCFSKZ.js";

// src/hovercard/hovercard-store.ts
import * as Core from "@ariakit/core/hovercard/hovercard-store";
function useHovercardStoreProps(store, update, props) {
  useStoreProps(store, props, "timeout");
  useStoreProps(store, props, "showTimeout");
  useStoreProps(store, props, "hideTimeout");
  return usePopoverStoreProps(store, update, props);
}
function useHovercardStore(props = {}) {
  const [store, update] = useStore(Core.createHovercardStore, props);
  return useHovercardStoreProps(store, update, props);
}

export {
  useHovercardStoreProps,
  useHovercardStore
};
